var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.shows ? _c('v-sheet', {
    staticClass: "client-push-banner",
    attrs: {
      "color": "grey lighten-4"
    }
  }, [_c('v-container', {
    staticClass: "py-8px"
  }, [_c('v-row', {
    staticClass: "flex-nowrap",
    attrs: {
      "no-gutters": "",
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "font-size-14 pr-8px"
  }, [_c('v-icon', {
    staticClass: "mr-4px",
    attrs: {
      "small": "",
      "color": "primary"
    }
  }, [_vm._v("mdi-bell-ring-outline")]), _vm._v(" " + _vm._s(_vm.texts.banner) + " ")], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "color": "primary",
      "elevation": "0",
      "loading": _vm.loading,
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.enable
    }
  }, [_vm._v(_vm._s(_vm.texts.button))])], 1), _c('v-col', {
    staticClass: "ml-4px",
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "small": "",
      "aria-label": "닫기"
    },
    on: {
      "click": _vm.hide
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-close")])], 1)], 1)], 1)], 1)], 1) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }